module.exports = __webpack_public_path__ + "static/r-success.99806cfd.png";